import { atom } from 'jotai'
import { ProdutosStatus, TypeServico } from '@/lib/enums'

export type Product = {
  id: string
  id_tenant: string
  id_user: string
  id_client: string
  typeServico: TypeServico
  status: ProdutosStatus
  typeRegime: string
  id_analista: string
  nomeAnalista: string
  senhaProduto: string
  empresa: string
  parceiro: string
}
export type ProductFull = {
  id: string
  id_tenant: string
  id_user: string
  id_client: string
  typeServico: TypeServico
  status: ProdutosStatus
  typeRegime: string
  id_analista: string
  nomeAnalista: string
  senhaProduto: string
}

export const selectedProductAtom = atom<Product | null>(null)

export enum TypeServicoValid {
  PREVIDENCIARIO = TypeServico.PREVIDENCIARIO,
  PIS_COFINS_MONOFASICO_PARA_SN = TypeServico.PIS_COFINS_MONOFASICO_PARA_SN,
  ALIQUOTA_ZERO = TypeServico.ALIQUOTA_ZERO,
  DESPESAS_OPERACIONAIS = TypeServico.DESPESAS_OPERACIONAIS,
  EXCLUSAO_DE_ICMS_E_ST = TypeServico.EXCLUSAO_DE_ICMS_E_ST,
  APURACAO_ST = TypeServico.APURACAO_ST,
  SUBVENCAO = TypeServico.SUBVENCAO,
  NEGOCIACAO_DE_PASSIVOS = TypeServico.NEGOCIACAO_DE_PASSIVOS,
  PARCERIA_COMERCIAL = TypeServico.PARCERIA_COMERCIAL,
  INSS_ACIMA_DO_TETO = TypeServico.INSS_ACIMA_DO_TETO,
  FCVS = TypeServico.FCVS,
  MVA = TypeServico.MVA
}
export type TypeViewProduct =
  | 'GERAL'
  | 'ALIQUOTA_ZERO'
  | 'PREVIDENCIARIO'
  | 'MVA'
  | 'SUBVENCAO'
  | 'PIS_COFINS_MONOFASICO_PARA_SN'
  | 'EXCLUSAO_ICMS'
  | 'FCVS'
